import React, { Dispatch, createContext, useState } from 'react';

const defaultSetShowMobileNavigationRail: Dispatch<React.SetStateAction<
  boolean
>> = () => {};

const MobileNavigationRailContext = createContext({
  showMobileNavigationRail: false,
  setShowMobileNavigationRail: defaultSetShowMobileNavigationRail
});

// This is too simple of a context provider to justify existing.
// Because of the way order summary currently works, I'm just leaving it.
// If we get to experiment with the deal drawer that should replace this,
// we can remove this stuff altogether. Until then I'm not overthinking it.
// For anyone curious, we keep the state here rather than the app level
// to prevent a re-render of the whole application shell when the state
// changes.
const MobileNavigationRailContextProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children
}) => {
  const [showMobileNavigationRail, setShowMobileNavigationRail] = useState(
    false
  );

  return (
    <MobileNavigationRailContext.Provider
      value={{ showMobileNavigationRail, setShowMobileNavigationRail }}
    >
      {children}
    </MobileNavigationRailContext.Provider>
  );
};

export default MobileNavigationRailContext;
export { MobileNavigationRailContextProvider };
